import React, {FC} from 'react';

import {useDeepMemo} from '../../libs/shared/helpers/src/react/hooks/hookHelpers';

/*
 * Props.
 */

interface DateFormatProps {
  value: Date | string;
  format: Intl.DateTimeFormatOptions | undefined;
}

/*
 * Component.
 */

/** @deprecated Provided only to transition away from Lingui 2.x. */
export const DateFormat: FC<DateFormatProps> = ({value, format}) => {
  const date = typeof value === 'string' ? new Date(value) : value;
  const formatter = useDeepMemo(() => new Intl.DateTimeFormat('en', format), [format]);

  return <>{formatter.format(date)}</>;
};
